import { z } from 'zod'

const assessExperienceSchema = z.object({
  investmentExperience: z.object({
    value: z.enum(['experienced', 'intermediate', 'novice']),
    score: z.number(),
  }),
})

type AssessExperienceSchema = z.infer<typeof assessExperienceSchema>

export { assessExperienceSchema, type AssessExperienceSchema }
